// extracted by mini-css-extract-plugin
export default {"input":"_1F1fT","wrapper":"_3PtEL","checkbox":"_1by1O","label":"_1AO01"};